import { routeToLoginOnDeadSession } from 'lib/authToken'

/* Raw fetches bypass the shared axios instance and its 401 handling. Call this right after the
 * fetch resolves: a 401 sends the user through dead-session recovery once and returns true; any
 * other status returns false so the caller keeps its own handling. The request is never retried. */
export const routeToLoginIfUnauthorized = (response: { status: number }): boolean => {
  if (response.status === 401) {
    routeToLoginOnDeadSession()
    return true
  }
  return false
}
